<!--充值返现配置-->
<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table :data="dataList" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
              class="custom-tbl" style="width: 100%">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="Id" width="80"></el-table-column>
      <el-table-column prop="RechargeAmount" label="充值金额" width="" sortable>
      </el-table-column>
      <el-table-column prop="CashbackAmount" label="返现金额" width="" sortable>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50" :total="total"
                     style="float: right">
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" ref="editForm">
        <el-form-item label="充值金额" prop="RechargeAmount">
          <el-input-number v-model="editForm.RechargeAmount" :min="0" :max="1000"></el-input-number>
        </el-form-item>
        <el-form-item label="返现金额" prop="CashbackAmount">
          <el-input-number v-model="editForm.CashbackAmount" :min="0" :max="1000"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-form-item label="充值金额" prop="RechargeAmount">
          <el-input-number v-model="addForm.RechargeAmount" :min="0" :max="1000"></el-input-number>
        </el-form-item>
        <el-form-item label="返现金额" prop="CashbackAmount">
          <el-input-number v-model="addForm.CashbackAmount" :min="0" :max="1000"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getRechargeCashbackConfig,
  addRechargeCashbackConfig,
  updateRechargeCashbackConfig,
  deleteRechargeCashbackConfig
} from "../../api/api";
import {
  getButtonList
} from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: {
    Toolbar
  },
  data() {
    return {
      filters: {
        name: "",
      },
      dataList: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: {
        RechargeAmount: 1,
        CashbackAmount: 1,
      },

      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {
        RechargeAmount: 1,
        CashbackAmount: 1,
      },
    };
  },
  methods: {
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatSex: function (row, column) {
      return row.sex == 1 ? "男" : row.sex == 0 ? "女" : "未知";
    },
    formatBirth: function (row, column) {
      return !row.birth || row.birth == "" ?
          "" :
          util.formatDate.format(new Date(row.birth), "yyyy-MM-dd");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        key: this.filters.name,
      };
      this.listLoading = true;

      //NProgress.start();
      getRechargeCashbackConfig(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.dataList = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
          .then(() => {
            this.listLoading = true;
            //NProgress.start();
            let para = {
              id: row.Id
            };
            deleteRechargeCashbackConfig(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.listLoading = false;
                return;
              }
              this.listLoading = false;
              //NProgress.done();
              if (res.data.success) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }

              this.handleQuery();
            });
          })
          .catch(() => {
          });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      this.options = [];
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.options = [];
      this.addForm = {
        RechargeAmount: 1,
        CashbackAmount: 1,
      };

      let para = {
        pid: 0
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          //NProgress.start();
          let para = Object.assign({}, this.editForm);
          updateRechargeCashbackConfig(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.editLoading = false;
              return;
            }
            if (res.data.success) {
              this.editLoading = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.$refs["editForm"].resetFields();
              this.options = [];
              this.editFormVisible = false;
              this.handleQuery();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          //NProgress.start();
          let para = Object.assign({}, this.addForm);
          addRechargeCashbackConfig(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.addLoading = false;
              return;
            }

            if (res.data.success) {
              this.addLoading = false;
              //NProgress.done();
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.$refs["addForm"].resetFields();
              this.options = [];
              this.addFormVisible = false;
              this.handleQuery();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
  },
  mounted() {
    this.handleQuery();

    let routers = window.localStorage.router ?
        JSON.parse(window.localStorage.router) :
        [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
